<template><!-- svgo-optimised -->
<svg class="icon icon__arrow icon__arrow--chevron-left" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m9.677 12 5.293-5.293L14.263 6l-6 6 6.03 6.03.707-.707L9.677 12Z" /></svg></template>